import { Node, useNode } from "@craftjs/core";
import * as React from "react";

import type { SpeakerLayout } from "./speakers-component";

type SpeakersListProps = {
  children: React.ReactNode;
  layout: SpeakerLayout;
};

const isNodeAllowed = (type) => ["SpeakerCard"].includes(type);

export default function SpeakersList(props: SpeakersListProps) {
  const {
    connectors: { connect },
  } = useNode();

  const listStyle: React.CSSProperties = React.useMemo(() => {
    if (props.layout === "large-cards") {
      return {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
      };
    }
    return undefined;
  }, [props.layout]);

  return (
    <div ref={connect} style={listStyle}>
      {props.children}
    </div>
  );
}

SpeakersList.craft = {
  custom: {
    displayName: "Speakers List",
  },
  rules: {
    canMoveIn: (nodes: Node[]) => {
      const nodeTypes = nodes?.map((node) => node?.type);
      return nodeTypes.length > 0 && nodeTypes.every(isNodeAllowed);
    },
  },
};
